module.exports = __webpack_public_path__ + "static/media/UPI.34fb5d53.jpg";